import { render, staticRenderFns } from "./sceneList.vue?vue&type=template&id=487191d4"
import script from "./sceneList.vue?vue&type=script&lang=js"
export * from "./sceneList.vue?vue&type=script&lang=js"
import style0 from "./sceneList.vue?vue&type=style&index=0&id=487191d4&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports